"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var DocumentIcon = function DocumentIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#333F48' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 20 : _ref$size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3334 0.333252H2.66675C1.56256 0.333252 0.666748 1.22906 0.666748 2.33325V15.6666C0.666748 16.7708 1.56256 17.6666 2.66675 17.6666H13.3334C14.4376 17.6666 15.3334 16.7708 15.3334 15.6666V2.33325C15.3334 1.22906 14.4376 0.333252 13.3334 0.333252ZM2.66675 1.66659H13.3334C13.7012 1.66659 14.0001 1.96544 14.0001 2.33325V15.6666C14.0001 16.0344 13.7012 16.3333 13.3334 16.3333H2.66675C2.29894 16.3333 2.00008 16.0344 2.00008 15.6666V2.33325C2.00008 1.96544 2.29894 1.66659 2.66675 1.66659ZM8.66675 12.3333V10.9999H4.00008V12.3333H8.66675ZM12.0001 4.33325V5.66658H4.00008V4.33325H12.0001ZM12.0001 8.99992V7.66659H4.00008V8.99992H12.0001Z",
    fill: color
  }));
};
var _default = DocumentIcon;
exports.default = _default;